<template>
    <div class="public-fights-queue-header">
        <div class="columns is-mobile is-vcentered">
            <div class="column is-half">
                <h1 class="title is-4">{{ store.eventName }}</h1>
            </div>
            <div class="column is-half has-text-right">
                <div class="current-time-info">
                    <span class="current-time">
                        <span class="icon"><i class="fa fa-clock" /></span>
                        {{ currentTime }}
                    </span>
                    <span v-if="store.isLoading" class="countdown-badge loading">
                        <span class="icon"><i class="fa fa-spinner fa-spin" /></span>
                        {{ translate("announcer_board.loading") }}
                    </span>
                    <span v-else class="countdown-badge">
                        <span class="icon"><i class="fa fa-sync-alt" /></span>
                        {{ store.timer }} {{ translate("announcer_board.seconds_left") }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { usePublicFightsQueueStore } from "./publicFightsQueueStore";
    import { onMounted, onUnmounted, ref } from "vue";
    import { translate } from "../Common/translations";
    const store = usePublicFightsQueueStore();
    const currentTime = ref("");

    function updateCurrentTime() {
        const now = new Date();
        currentTime.value = now.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
        });
    }

    let timeInterval: ReturnType<typeof setInterval> | null = null;

    onMounted(() => {
        updateCurrentTime();
        timeInterval = setInterval(updateCurrentTime, 1000);
    });

    onUnmounted(() => {
        if (timeInterval) {
            clearInterval(timeInterval);
        }
    });
</script>

<style scoped>
    .public-fights-queue-header {
        padding: 1rem 0;
        border-bottom: 2px solid #e0e0e0;
        margin-bottom: 1rem;
    }

    .title {
        margin: 0;
        color: #f5f5f5;
    }

    .current-time-info {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 1rem;
    }

    .current-time {
        font-size: 1.5rem;
        font-weight: bold;
        color: #f5f5f5;
    }

    .countdown-badge {
        background-color: #3273dc;
        color: white;
        padding: 0.5rem 1rem;
        border-radius: 4px;
        font-size: 1rem;
        font-weight: 500;
        min-width: 150px;
        display: inline-block;
        text-align: center;
    }
</style>
